
  export default {
    props: {
      linksData: {
        default: null
      },
    },

  }
